class BenefitChangedPriceSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    const oldBenefit =
      systemNotificationPayloadData.old_benefit ||
      systemNotificationPayloadData.oldBenefit ||
      {};

    const updatedBenefit =
      systemNotificationPayloadData.updated_benefit ||
      systemNotificationPayloadData.updatedBenefit ||
      {};

    this.id =
      systemNotificationPayloadData.id ||
      updatedBenefit.id ||
      oldBenefit.id ||
      "";

    this.title =
      systemNotificationPayloadData.title ||
      updatedBenefit.title ||
      oldBenefit.title ||
      "";

    this.tokenPrice =
      systemNotificationPayloadData.tokenPrice ||
      systemNotificationPayloadData.token_price ||
      updatedBenefit.tokenPrice ||
      updatedBenefit.token_price ||
      oldBenefit.tokenPrice ||
      oldBenefit.token_price ||
      "";
  }
}

export default BenefitChangedPriceSystemNotificationPayload;
